// /**
//  * add to cart
//  */
//
// if (typeof addedToCartText == 'undefined') {
//     var addedToCartText = '';
// }
//
// $.notify.addStyle("rgb-notification", {
//     html:
//         "<div>" +
//             "<div class='notify-title'>"+addedToCartText+":</div>" +
//             "<div class='image' data-notify-html='image'></div>" +
//             "<div class='text-wrapper'>" +
//                 "<div class='title' data-notify-html='title'></div>" +
//                 "<div class='price' data-notify-html='price'></div>" +
//             "</div>" +
//         "</div>",
//     classes: {
//         white: {
//             //"background-color": "#f1f1f1",
//             //"border": "1px solid #ddd",
//             //"padding": "20px"
//         }
//     }
// });
//
// /**
//  * availability
//  */
// $.notify.addStyle("rgb-notification-availibility", {
//     html:
//         '<div>'                                                                                             +
//             '<div class="panel panel-default">'                                                             +
//                 '<div class="panel-heading">'                                                               +
//                     '<h3 class="panel-title">'                                                              +
//                         '<i class="fa fa-times-circle font-22 c-white" aria-hidden="true"></i> '            +
//                         '<span class="font-17 c-white thickness-bold" data-notify-html="title">'            +
//                         '</span>'                                                                           +
//                     '</h3>'                                                                                 +
//                 '</div>'                                                                                    +
//                 '<div class="panel-body">'                                                                  +
//                     '<p class="font-15 c-brown" data-notify-html="content">'                                +
//                     '</p>'                                                                                  +
//                 '</div>'                                                                                    +
//                 '<div class="panel-footer" data-notify-html="footer">'                                      +
//                 '</div>'                                                                                    +
//             '</div>'                                                                                        +
//         '</div>',
//     classes: {
//         white: {
//             //"background-color": "#f1f1f1",
//             //"border": "1px solid #ddd",
//             //"padding": "20px"
//         }
//     }
// });
//
// /**
//  * incoming orders
//  */
// $.notify.addStyle("rgb-notification-incoming-orders", {
//     html:
//         '<div>'                                                                                             +
//             '<div class="panel panel-default">'                                                             +
//                 '<div class="panel-heading">'                                                               +
//                     '<h3 class="panel-title">'                                                              +
//                         '<i class="fa fa-clock-o font-22 c-white" aria-hidden="true"></i> '                 +
//                         '<span class="font-17 c-white thickness-bold" data-notify-html="title">'            +
//                         '</span>'                                                                           +
//                         '<div class="button-close" data-notify-html="close">'                               +
//                         '</div>'                                                                            +
//                     '</h3>'                                                                                 +
//                 '</div>'                                                                                    +
//                 '<div class="panel-body">'                                                                  +
//                     '<div data-notify-html="content">'                                                      +
//                     '</div>'                                                                                +
//                 '</div>'                                                                                    +
//             '</div>'                                                                                        +
//         '</div>',
//     classes: {
//         white: {
//             //"background-color": "#f1f1f1",
//             //"border": "1px solid #ddd",
//             //"padding": "20px"
//         }
//     }
// });
//
// /**
//  * shipping costs
//  */
// $.notify.addStyle("rgb-notification-shipping-costs", {
//     html:
//         '<div>'                                                                                             +
//             '<div class="panel panel-default">'                                                             +
//                 '<div class="panel-heading">'                                                               +
//                     '<h3 class="panel-title">'                                                              +
//                         '<i class="fa fa-times-circle font-22 c-white" aria-hidden="true"></i> '            +
//                         '<span class="font-17 c-white thickness-bold" data-notify-html="title">'            +
//                         '</span>'                                                                           +
//                         '<div class="button-close" data-notify-html="close">'                               +
//                         '</div>'                                                                            +
//                     '</h3>'                                                                                 +
//                 '</div>'                                                                                    +
//                 '<div class="panel-body">'                                                                  +
//                     '<p class="font-15 c-brown" data-notify-html="content">'                                +
//                     '</p>'                                                                                  +
//                 '</div>'                                                                                    +
//                 '<div class="panel-footer" data-notify-html="footer">'                                      +
//                 '</div>'                                                                                    +
//             '</div>'                                                                                        +
//         '</div>',
//     classes: {
//         white: {
//             //"background-color": "#f1f1f1",
//             //"border": "1px solid #ddd",
//             //"padding": "20px"
//         }
//     }
// });